/* eslint-disable react-hooks/rules-of-hooks */
import { EMyHomeEstimationTargets } from '../../../types/estimationTarget';
import { useSelector } from 'react-redux';
import { selectEstimationTarget, selectIsNewbuilding } from '../../../selectors';
import { useActions } from '../../../hooks';

export const getSubmitAction = () => {
  const estimationTarget = useSelector(selectEstimationTarget);

  const { submitFlatData, submitSuburbanData, submitNewbuildingData } = useActions();

  const isNewbuilding = useSelector(selectIsNewbuilding);
  const isSuburban = [EMyHomeEstimationTargets.house, EMyHomeEstimationTargets.land].includes(estimationTarget);

  if (isSuburban) {
    return submitSuburbanData;
  }

  if (isNewbuilding) {
    return submitNewbuildingData;
  }

  return submitFlatData;
};
